const titles = ['內容', '形式']

export const promotion = {
  title: '業配宣傳', steps: [
    {
      title: titles[0], options: [
        '商品推薦',
        '試用心得',
        '抽獎贈獎',
      ]
    },
    {
      title: titles[1], options: [
        'IG 貼文',
        '限時動態',
        'FB 貼文',
        '其他社群媒體',
      ]
    },
  ]
}

export const marketing = {
  title: '行銷設計', steps: [
    {
      title: titles[0], options: [
        '品牌宣傳',
        '商品介紹',
        '社會公益',
        '政府合作',
      ]
    },
    {
      title: titles[1], options: [
        '整合行銷',
        '圖文委製',
        '故事插畫',
        '印刷出版',
        '影音製作',
      ]
    },
  ]
}

export const developing = {
  title: '商品開發', steps: [
    {
      title: titles[0], options: [
        '作品授權',
        '原創繪製',
      ]
    },
    {
      title: titles[1], options: [
        '書籍出版',
        '周邊商品',
        '特殊企劃商品',
      ]
    },
  ]
}

export const illustrtion = {
  title: '插畫設計', steps: [
    {
      title: titles[0], options: [
        '插畫委託',
        '設計委託',
        '產品設計',
        '作品授權',
      ]
    },
    {
      title: titles[1], options: [
        '商業用途',
        '個人用途',
        '社會公益',
        '政府合作',
      ]
    },
  ]
}

export const professional = {
  title: '專業合作', steps: [
    {
      title: titles[0], options: [
        '書籍出版',
        '書籍推薦',
        '文章邀稿',
        '專欄撰寫',
        '專案顧問',
        '專案執行',
        '其他',
      ]
    },
    {
      title: titles[1], options: [
        '出版社',
        '商業邀請',
        '社會公益',
        '政府合作',
      ]
    },
  ]
}

export const activity = {
  title: '活動邀請', steps: [
    {
      title: titles[0], options: [
        '活動出席',
        '課程教學',
        '演講邀約',
        '品牌代言',
        '其他',
      ],
    },
    {
      title: titles[1], options: [
        '實體活動',
        '線上活動',
      ],
    },
  ]
}
